import axios from 'axios'
import store from '@/store'
import router from '@/router'

export default {
  async execute (method, resource, data) {
    // inject the accessToken for each request
    let accessToken = await store.getters.token
    return axios({
      method,
      json: true,
      url: resource,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(req => {
      return req.data
    }).catch(error => {
      const { response } = error
      const { request, ...errorObject } = response // take everything but 'request'
      if (errorObject.status === 401) {
        store.dispatch('LogOut')
        router.push('/Projekte')
      }
    })
  },
  refresh () {
    return this.execute('get', `/api/user/refresh`, {})
  },
  clearLogo (id) {
    return this.execute('get', `/api/user/clearLogo/${id}`, {})
  },
  setLogo (id, data) {
    return this.execute('post', `/api/user/setLogo/${id}`, data)
  },
  setKunden (id, data) {
    return this.execute('post', `/api/user/setKunden/${id}`, data)
  },
  addFilm (id, data) {
    return this.execute('post', `/api/user/addFilm/${id}`, data)
  },
  updateFilm (id, filmografie) {
    return this.execute('post', `/api/user/updateFilm/${id}`, filmografie)
  },
  deleteFilm (id, filmid) {
    return this.execute('delete', `/api/user/deleteFilm/${id}/${filmid}`)
  },
  updateSendung (id, data) {
    return this.execute('post', `/api/user/updateSendung/${id}`, data)
  },
  deleteSendung (id, sendungid) {
    return this.execute('delete', `/api/user/deleteSendung/${id}/${sendungid}`)
  },
  acceptAGB () {
    return this.execute('get', '/api/user/acceptAGB')
  },
  list (offset, size, filter) {
    let params = ''
    if (filter.name) {
      params = '?name=' + encodeURI(filter.name)
    }
    return this.execute('get', '/api/user/list/' + offset + '/' + size + params)
  },
  search (offset, size, data) {
    let params = '?'
    for (let key of Object.keys(data)) {
      if (data[key]) {
        params = params + key + '=' + data[key] + '&'
      }
    }
    return this.execute('get', '/api/user/search/' + offset + '/' + size + params)
  },
  get (id) {
    return this.execute('get', `/api/user/get/${id}`)
  },
  update (id, data) {
    return this.execute('post', `/api/user/update/${id}`, data)
  },
  delete (url) {
    return this.execute('delete', url)
  },
  changePassword (id, data) {
    return this.execute('post', `/api/user/changePassword/${id}`, data)
  },
  suggest (what, data) {
    return this.execute('get', `/api/user/suggest/${what}/${data}`)
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/api/benutzer.js